import type { ReactNode } from 'react';

export const symbol_artist: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M616-189q-29-29-29-76t29-76q29-29 76-29 17 0 31 4t25 12v-176q0-12.75 8.63-21.38Q765.25-560 778-560h72q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-53v235q0 47-29 76t-76 29q-47 0-76-29Zm-506 29q-12.75 0-21.37-8.63Q80-177.25 80-190v-64q0-32 17-61.5t51-44.5q75-33 133.39-46.5Q339.78-420 400-420q35 0 68.5 4.5T537-402q16 5 21 15.38t3 21.5Q559-354 550-347q-9 7-22 3-29-8-61.21-12-32.22-4-66.79-4-58 0-109 11t-119 43q-16 8-24 22.5t-8 29.5v34h372q15 0 22.5 9.32t7.5 20.5q0 11.18-7.75 20.68T511-160H110Zm182-363q-42-42-42-108t42-108q42-42 108-42t108 42q42 42 42 108t-42 108q-42 42-108 42t-108-42Zm172.5-43.5Q490-592 490-631t-25.5-64.5Q439-721 400-721t-64.5 25.5Q310-670 310-631t25.5 64.5Q361-541 400-541t64.5-25.5ZM400-631Zm0 411Z"
		/>
	</svg>
);
